// Đợt Offline-3 — Preload chunk các route public chính lúc RẢNH (idle) với
// jitter 5-30s: khi offline, React.lazy các trang này đã sẵn trong memory
// → SPA điều hướng được mà không cần mạng. Chạy đúng 1 lần/app-session.
import * as governor from "./networkGovernor";

let _scheduled = false;

export function scheduleOfflineRoutePreload(importFns) {
  if (_scheduled || typeof window === "undefined") return;
  _scheduled = true;
  const run = () => {
    const go = () => {
      importFns.forEach((fn) => {
        try { Promise.resolve(fn()).catch(() => {}); } catch { /* noop */ }
      });
    };
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(go, { timeout: 10_000 });
    } else {
      setTimeout(go, 2_000);
    }
  };
  const delay = 5_000 + Math.random() * 25_000; // jitter 5-30s
  setTimeout(() => {
    if (governor.isOffline()) {
      // Đang offline lúc đến giờ → chờ online rồi mới tải chunk.
      const unsub = governor.subscribe((s) => {
        if (s.state === "online") { unsub(); run(); }
      });
    } else {
      run();
    }
  }, delay);
}

// Chỉ dùng cho unit test.
export function _resetPreloadForTest() { _scheduled = false; }
